export default function anonymous(props
) {
var out='<div class="'+(props.styles.iconContainer)+'" data-playable-component></div>';return out;
}